import { isLookAccessible } from './look';
import { TArtist } from '../typings';

export const getFullArtistName = (artist: TArtist) =>
  [artist.name, artist.second_name, artist.last_name].filter((elem) => elem).join(' ');

export const numberOfLooks = (artist: TArtist) => artist.stores.filter(isLookAccessible).length;
